var _style, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000147929983206881319160000015038521559229073038_);}\n\t.st2{fill:url(#SVGID_00000130607531414105703160000004398674364645879455_);}\n\t.st3{fill:url(#SVGID_00000085940081175078334910000010696202393461523618_);}\n\t.st4{fill:url(#SVGID_00000172405895267706746530000007734869808594251955_);}\n\t.st5{fill:url(#SVGID_00000063596517883501908670000012030896279253966465_);}\n\t.st6{fill:url(#SVGID_00000099651571421043906830000018258275215621382052_);}\n\t.st7{fill:url(#SVGID_00000084497780829157002800000000213516077155785894_);}\n\t.st8{fill:url(#SVGID_00000070080311750199568740000016124920805971509176_);}\n\t.st9{fill:url(#SVGID_00000153675784151386108570000018271809823008142522_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -306.5007,
    y1: 1570.3881,
    x2: -306.3663,
    y2: 1595.5225,
    gradientTransform: "matrix(0.9166 0.3999 -0.3999 0.9166 935.4604 -1286.6462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E2123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3415,
    style: {
      stopColor: "#A02122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    style: {
      stopColor: "#C72917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8351,
    style: {
      stopColor: "#9E2123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C72917"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.7,57.5 34.1,33.7 18.9,27.1 8.5,50.9 19.4,46.6  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047780039019881664760000010664685461320014246_",
    gradientUnits: "userSpaceOnUse",
    x1: 7400.7236,
    y1: 1546.5485,
    x2: 7401.1284,
    y2: 1622.3046,
    gradientTransform: "matrix(-0.9166 -0.3999 0.3999 -0.9166 6166.6016 4483.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#9E2123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9282,
    style: {
      stopColor: "#FBB03B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047780039019881664760000010664685461320014246_)"
    },
    points: "33.1,33.3 33.5,33.5 23.4,56.6  23.2,56.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073707479476467950030000009491524237237179311_",
    gradientUnits: "userSpaceOnUse",
    x1: 7415.4839,
    y1: 1546.8065,
    x2: 7415.8877,
    y2: 1622.3165,
    gradientTransform: "matrix(-0.9166 -0.3999 0.3999 -0.9166 6166.6016 4483.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#9E2123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9282,
    style: {
      stopColor: "#FBB03B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000073707479476467950030000009491524237237179311_)"
    },
    points: "19.6,27.4 19.9,27.6 10,50.3  9.5,50.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052065961436897231500000001230610738774276488_",
    gradientUnits: "userSpaceOnUse",
    x1: 6228.9624,
    y1: -1281.0868,
    x2: 6229.0967,
    y2: -1255.9523,
    gradientTransform: "matrix(-0.9166 0.3999 0.3999 0.9166 6254.9805 -1286.6462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E2123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3415,
    style: {
      stopColor: "#A02122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    style: {
      stopColor: "#C72917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8351,
    style: {
      stopColor: "#9E2123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C72917"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000052065961436897231500000001230610738774276488_)"
    },
    points: "36.3,57.5 25.9,33.7 41.1,27.1  51.5,50.9 40.6,46.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100354989220308545440000011041106555769395595_",
    gradientUnits: "userSpaceOnUse",
    x1: 865.2604,
    y1: 4398.0234,
    x2: 865.6655,
    y2: 4473.7793,
    gradientTransform: "matrix(0.9166 -0.3999 -0.3999 -0.9166 1023.839 4483.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#9E2123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9282,
    style: {
      stopColor: "#FBB03B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000100354989220308545440000011041106555769395595_)"
    },
    points: "26.9,33.3 26.5,33.5 36.6,56.6  36.8,56.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039833431590611442990000002541735285403643559_",
    gradientUnits: "userSpaceOnUse",
    x1: 880.0211,
    y1: 4398.2812,
    x2: 880.4249,
    y2: 4473.7915,
    gradientTransform: "matrix(0.9166 -0.3999 -0.3999 -0.9166 1023.839 4483.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#9E2123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9282,
    style: {
      stopColor: "#FBB03B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000039833431590611442990000002541735285403643559_)"
    },
    points: "40.4,27.4 40.1,27.6 50,50.3  50.5,50.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080190511534249302680000011729758269787668387_",
    gradientUnits: "userSpaceOnUse",
    x1: -228.2108,
    y1: 2435.7756,
    x2: -190.2207,
    y2: 2435.7756,
    gradientTransform: "matrix(0.804 0.5947 -0.5947 0.804 1646.3042 -1812.3477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3686,
    style: {
      stopColor: "#D67832"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9282,
    style: {
      stopColor: "#FBB03B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000080190511534249302680000011729758269787668387_)"
    },
    cx: 29.6,
    cy: 21.5,
    r: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127741265436239896390000008488842469578796937_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.8225,
    y1: 7.9477,
    x2: 39.7893,
    y2: 39.3185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2058,
    style: {
      stopColor: "#D67832"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9282,
    style: {
      stopColor: "#FBB03B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127741265436239896390000008488842469578796937_)"
    },
    d: "M45.3,16.6C42.6,7.9,33.4,3,24.7,5.7 c-8.7,2.7-13.5,12-10.8,20.7c2.7,8.7,12,13.5,20.7,10.8C43.2,34.5,48.1,25.3,45.3,16.6z M34.2,36.2c-8.1,2.5-16.8-2-19.3-10.1 C12.3,18,16.9,9.3,25,6.8c8.1-2.5,16.8,2,19.3,10.1C46.8,25,42.3,33.7,34.2,36.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147898581096078350080000014649106259815239318_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.8225,
    y1: 7.9477,
    x2: 39.7894,
    y2: 39.3184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2058,
    style: {
      stopColor: "#D67832"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9282,
    style: {
      stopColor: "#FBB03B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147898581096078350080000014649106259815239318_)"
    },
    d: "M25,6.8C16.9,9.3,12.3,18,14.9,26.1 c2.5,8.1,11.2,12.6,19.3,10.1c8.1-2.5,12.6-11.2,10.1-19.3C41.7,8.8,33.1,4.3,25,6.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022548651645022925730000009980626882501911435_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5822,
    y1: 9.3758,
    x2: 29.5822,
    y2: 45.1764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5251,
    style: {
      stopColor: "#FBB03B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9282,
    style: {
      stopColor: "#FBB03B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022548651645022925730000009980626882501911435_)"
    },
    d: "M25,6.8C16.9,9.3,12.3,18,14.9,26.1 c2.5,8.1,11.2,12.6,19.3,10.1c8.1-2.5,12.6-11.2,10.1-19.3C41.7,8.8,33.1,4.3,25,6.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalla);
export default __webpack_public_path__ + "static/media/medalla.bacb393ed4f87fb78cbf91e16939c041.svg";
export { ForwardRef as ReactComponent };